<template>
  <header
    class="h-[3.75rem] bg-primary flex justify-between items-center px-4 sm:px-8 relative z-50"
  >
    <div class="text-white font-semibold">
      <a href="/">Proactive Ecoland</a>
    </div>

    <div></div>

    <div class="hidden sm:block relative">
      <a
        href="/news"
        target="_blank"
        rel="noopener noreferrer"
        class="absolute left-0 -translate-x-[105%] top-1/2 -translate-y-1/2"
      >
        <button class="btn btn-sm btn-secondary text-xs hidden xl:inline-flex">
          {{ $t('missions') }}
        </button>
      </a>
      <slot />
    </div>

    <div class="flex space-x-2 items-center">
      <a
        href="https://drive.google.com/drive/folders/1KZaySQGiqDvP1sPuEJMS_IGrfK1uBrre"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button class="btn btn-sm btn-secondary text-xs hidden xl:inline-flex">
          {{ $t('downloadMaterials') }}
        </button>
      </a>
      <a href="https://youtu.be/L7CUtuJC--g" target="_blank" rel="noopener noreferrer">
        <button class="btn btn-sm btn-secondary text-xs hidden xl:inline-flex">
          {{ $t('videoTutorial') }}
        </button>
      </a>
      <a href="https://www.footprintcalculator.org/home" target="_blank" rel="noopener noreferrer">
        <button class="btn btn-sm btn-secondary text-xs hidden xl:inline-flex">
          {{ $t('footprintCalculator') }}
        </button>
      </a>

      <div class="dropdown dropdown-end inline-block xl:hidden">
        <div tabindex="0" role="button" class="btn btn-secondary btn-sm m-1">{{ $t('links') }}</div>
        <ul tabindex="0" class="dropdown-content z-50 menu p-2 shadow bg-base-100 rounded-box w-52">
          <li>
            <a href="https://proactive-ecoland.com/news" target="_blank" rel="noopener noreferrer">
              {{ $t('missions') }}
            </a>
          </li>
          <li>
            <a
              href="https://drive.google.com/drive/folders/1KZaySQGiqDvP1sPuEJMS_IGrfK1uBrre"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t('downloadMaterials') }}
            </a>
          </li>
          <li>
            <a href="https://youtu.be/L7CUtuJC--g" target="_blank" rel="noopener noreferrer">
              {{ $t('videoTutorial') }}
            </a>
          </li>
          <li>
            <a
              href="https://www.footprintcalculator.org/home"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ $t('footprintCalculator') }}
            </a>
          </li>
        </ul>
      </div>

      <div v-if="authToken" class="dropdown dropdown-end">
        <div tabindex="0" role="button" class="btn btn-sm m-1">{{ $t('admin') }}</div>
        <ul tabindex="0" class="dropdown-content z-50 menu p-2 shadow bg-base-100 rounded-box w-52">
          <li>
            <a href="/invite">{{ $t('invite') }}</a>
          </li>
          <li>
            <a href="/reports">{{ $t('reports') }}</a>
          </li>
        </ul>
      </div>

      <LanguageDropdown />
    </div>
  </header>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import LanguageDropdown from '@/components/LanguageDropdown.vue'

const authToken = ref('')

onMounted(() => {
  const storedToken = sessionStorage.getItem('authToken')

  authToken.value = storedToken ? storedToken : ''
})
</script>
